function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DateTimeColumnFormatter, TableUtils } from '@deephaven/jsapi-utils';
import FormatContextMenuUtils from "./FormatContextMenuUtils.js";
class DateTimeFormatContextMenu {
  /**
   * Creates list of formatting options for DateTime context menu
   * @param formatter Formatter instance
   * @param selectedFormat Selected format object, null for no selected format
   * @returns Array of formatting options for the context menu
   */
  static getOptions(formatter, selectedFormat) {
    var currentTime = new Date();
    var formatItems = [{
      group: DateTimeFormatContextMenu.dateGroup,
      formatString: 'yyyy-MM-dd'
    }, {
      group: DateTimeFormatContextMenu.dateGroup,
      formatString: 'MM-dd-yyyy'
    }, {
      group: DateTimeFormatContextMenu.timeGroup,
      formatString: 'HH:mm:ss'
    }, {
      group: DateTimeFormatContextMenu.timeGroup,
      formatString: 'HH:mm:ss.SSS'
    }, {
      group: DateTimeFormatContextMenu.timeGroup,
      formatString: 'HH:mm:ss.SSSSSSSSS'
    }, {
      group: DateTimeFormatContextMenu.dateTimeGroup,
      formatString: "yyyy-MM-dd HH:mm:ss"
    }, {
      group: DateTimeFormatContextMenu.dateTimeGroup,
      formatString: "yyyy-MM-dd HH:mm:ss.SSS"
    }, {
      group: DateTimeFormatContextMenu.dateTimeGroup,
      formatString: "yyyy-MM-dd HH:mm:ss.SSSSSSSSS"
    }];
    var presetFormatOptions = formatItems.map(item => {
      var format = DateTimeColumnFormatter.makeFormat('', item.formatString, DateTimeColumnFormatter.TYPE_CONTEXT_PRESET);
      var title = formatter.getFormattedString(currentTime, TableUtils.dataType.DATETIME, '', format);
      return FormatContextMenuUtils.makeOption(title, format, item.group, DateTimeColumnFormatter.isSameFormat(format, selectedFormat));
    });
    var defaultOption = FormatContextMenuUtils.makeOption('Default', null, DateTimeFormatContextMenu.dateGroup, FormatContextMenuUtils.isDefaultSelected(selectedFormat));
    return [defaultOption, ...presetFormatOptions];
  }
}
_defineProperty(DateTimeFormatContextMenu, "dateGroup", 10);
_defineProperty(DateTimeFormatContextMenu, "timeGroup", 20);
_defineProperty(DateTimeFormatContextMenu, "dateTimeGroup", 30);
export default DateTimeFormatContextMenu;
//# sourceMappingURL=DateTimeFormatContextMenu.js.map